/* eslint-disable */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslator } from '@jutro/locale';
import { Grid, GridItem } from '@jutro/layout';
import styles from './MLSidebarLinks.module.scss';
import { withRouter, Link } from 'react-router-dom';
import { MLPortalSettingsService } from 'gw-capability-quoteandbind';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { Icon } from '@jutro/legacy/components';

function MLSidebarLinks(props) {
    const { linksToRender, id } = props;
    const translator = useTranslator();
    const { authHeader } = useAuthentication();

     const [enableAskForemost, setEnableAskForemost] = useState(false)
    
    useEffect(() => {
        let isMounted = true;
        const loadAskForemostSettings = async () => {
            try {
                const portalSettings = await MLPortalSettingsService.getSettings(authHeader);
                if(!isMounted) return;
                const { enableAskForemost } = portalSettings;
                setEnableAskForemost(enableAskForemost)
            }
            catch {
                if(isMounted){
                    setEnableAskForemost(false)
                }
            }

        }
        loadAskForemostSettings()

        return () => {
            isMounted = false;
        }
    }, [authHeader]);

    const onAskForemostClick = () => {
        let url = '';
        if (window.location.hostname.includes('producer-engage-farmers')){
            url = '/producer-engage/ask-foremost'
        } else {
            url = '/ask-foremost';
        }
        window.open(url, '_blank');
    };

    return linksToRender.map(({ title, content, link }) => {
        const { url, name, linkId } = link;
        const isAskForemost = name.id === 'ml_sidebar.text.sections.media_sidebar.ask_foremost_link1';
        if(isAskForemost && !enableAskForemost) return;
        return (
            <div key={title} className={styles.gwMLSidebarLinksTextContainer} id={id}>
                <li>
                <Grid
                    columns={['0.1fr', '1fr']}
                    alignItems="left"
                    vgap="small"
                    hgap="small"
                >
                    <GridItem>
                        <Icon className={styles.accountIcon} icon="description" />
                    </GridItem>
                    {url !== '/faq' ?
                        (<GridItem>
                            {isAskForemost ? 
                                <a href="#" title="Opens in a new tab/window" target="_blank" className={styles.gwMLSidebarLink} onClick={onAskForemostClick}>
                                    {translator(name)}
                                </a> : 
                                (linkId !== 'mfa' ?
                                (<a title="Opens in a new tab/window" target="_blank" className={styles.gwMLSidebarLink} rel="noopener noreferrer" href={`${url}`}>
                                    {translator(name)}
                                </a> ) :
                                ( <a title="Opens in a new tab/window" className={styles.gwMLSidebarLink} 
                                    href={`javascript:window.open('${url}', '${translator(name)}', 'width=${screen.width - 100},height=${screen.height - 100}')`}>
                                {translator(name)}
                                </a>
                                ))
                            }
                        </GridItem>) :
                        (
                            <GridItem>
                                <Link to={url} className={styles.gwMLSidebarLink}> {translator(name)} </Link>
                            </GridItem>
                        )
                    }
                </Grid>
                </li>
            </div>
        );
    });
}

MLSidebarLinks.propTypes = {
    id: PropTypes.string,
    userType: PropTypes.string,
    linksToRender: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};

export default withRouter(MLSidebarLinks);
